import { render } from "./ExternalTransferRealtime.vue?vue&type=template&id=28fa4557&scoped=true"
import script from "./ExternalTransferRealtime.vue?vue&type=script&lang=js"
export * from "./ExternalTransferRealtime.vue?vue&type=script&lang=js"

import "./ExternalTransferRealtime.vue?vue&type=style&index=0&id=28fa4557&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fa4557"]])

export default __exports__